"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptDialog = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const dialog_1 = require("../../components/dialog/dialog");
const form_1 = require("../form/form");
exports.PromptDialog = react_1.forwardRef(function PromptDialog({ prompt, onConfirm, onCancel, loading }, ref) {
    var _a, _b;
    const formRef = react_1.useRef(null);
    const handleConfirm = event_callback_hook_1.useEventCallback(async () => {
        var _a, _b;
        if (!formRef.current) {
            onConfirm(undefined, formRef);
            return true;
        }
        const errors = await ((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.validateForm());
        if ((errors === null || errors === void 0 ? void 0 : errors.length) === 0) {
            const values = (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.getFieldValues();
            // dialog stays opened if result === true
            const result = await onConfirm(values, formRef);
            return !result;
        }
        else {
            return false;
        }
    });
    const handleCancel = event_callback_hook_1.useEventCallback(() => {
        var _a;
        if (ref !== null) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
        }
        onCancel();
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: prompt === null || prompt === void 0 ? void 0 : prompt.dialogTitle, showConfirm: (_a = prompt === null || prompt === void 0 ? void 0 : prompt.dialogShowConfirm) !== null && _a !== void 0 ? _a : true, onConfirm: handleConfirm, showClose: (_b = prompt === null || prompt === void 0 ? void 0 : prompt.dialogShowClose) !== null && _b !== void 0 ? _b : true, onCancel: onCancel, loading: loading }, () => {
        var _a, _b, _c;
        return (react_1.default.createElement("div", { style: { width: (_a = prompt === null || prompt === void 0 ? void 0 : prompt.dialogWidth) !== null && _a !== void 0 ? _a : 400 } },
            !!(prompt === null || prompt === void 0 ? void 0 : prompt.dialogText) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Typography_1.default, { component: "div" }, prompt === null || prompt === void 0 ? void 0 : prompt.dialogText),
                react_1.default.createElement("br", null))),
            (prompt === null || prompt === void 0 ? void 0 : prompt.FormFields) !== undefined && (react_1.default.createElement(form_1.Form, { ref: formRef, editing: true, initialValues: (_b = prompt === null || prompt === void 0 ? void 0 : prompt.formInitialValues) !== null && _b !== void 0 ? _b : {}, onSubmit: (_c = prompt === null || prompt === void 0 ? void 0 : prompt.formOnSubmit) !== null && _c !== void 0 ? _c : lodash_1.noop, validationSchema: prompt.formValidationSchema }, react_1.default.createElement(prompt.FormFields, { onConfirm: handleConfirm, onCancel: handleCancel, loading: loading })))));
    }));
});
//# sourceMappingURL=prompt-dialog.js.map